import { IQuestion } from 'app/interfaces/IQuestion'

export class QuestionPropertiesValidationError extends Error {
  constructor(missingProperties: string[], question: IQuestion) {
    super()
    this.name = 'Missing properties'
    this.message = `Question of type <${question.viewerType}> with key <${question.key}> is missing the following: ${missingProperties.join(', ')}.`
  }
}
